import './ArticleHeader.css';

function ArticleHeader({ title, date, author }) {
  const [day, month, year] = date.split('/').map(Number);
  const dateObj = new Date(year, month - 1, day);
  const authorName = author || 'Consulta Giovanile';

  return (
    <div className="article-header">
      <h1>{title}</h1>
      <div className="article-meta">
        <span className="article-author">
          <i className="fa-regular fa-user"></i> {authorName}
        </span>
        <span className="article-date">
          <i className="fa-regular fa-calendar"></i> {dateObj.toLocaleDateString('it-IT', { 
            day: 'numeric', 
            month: 'long', 
            year: 'numeric' 
          })}
        </span>
      </div>
    </div>
  );
}

export default ArticleHeader;
